const MnappList = () => import(/* webpackChunkName: 'wxminiapp' */ './mnappList');
const Success = () => import(/* webpackChunkName: 'wxminiapp' */ './success');
const Fail = () => import(/* webpackChunkName: 'wxminiapp' */ './fail');
const Auth = () => import(/* webpackChunkName: 'wxminiapp' */ './authorization');
const MnappCreate = () => import(/* webpackChunkName: 'wxminiapp' */ './mnappCreate');

const routes = [
  { path: '/wxminiapp/mnappList', component: MnappList, name: 'mnappList' },
  { path: '/wx/account/miniSuccess', component: Success },
  { path: '/wx/account/miniFail', component: Fail },
  { path: '/wxminiapp/auth', component: Auth },
  { path: '/wxminiapp/mnappCreate', component: MnappCreate }
];

export default routes;
